angular.module('autoremind.templates')
    .directive('browseUploadedImages', ['templateService', '$document',
    function (templateService, $document) {
        return {
            restrict: 'E',
            templateUrl: 'app/common/messages/browse-uploaded-images.html',
            link: function (scope, elem, attr) {
                scope.service = templateService;
                scope.viewModel = {
                    isAlreadyLoaded: false,
                    treedata: [],
                    loadingIndicator: {
                        refCount: 0,
                        state: true
                    },
                    hideAllUsersFolders: false,
                    hideCurrentUserFolders: false,
                    hideOldFolders: true,
                    hideTmpFolders: true
                };
                scope.checkUserFolder = function () {
                    if (!scope.service.userModel.userId) {
                        return;
                    }
                    scope.viewModel.isAlreadyLoaded = true;
                    for (var i in scope.viewModel.treedata) {
                        var item = scope.viewModel.treedata[i];
                        if (!isNaN(item.label) && (scope.service.userModel.userId).toString() === item.label) {
                            scope.viewModel.treedata[i].collapsed = false;
                            scope.loadDirStructure('/' + item.label + '/', { children: scope.viewModel.treedata[i].children }, scope.viewModel.treedata[i].loadingIndicator);
                        }
                    }
                };
                scope.loadDirStructure = function (path, model, loadingIndicator) {
                    if (!model.children || model.children.length > 0) {
                        return;
                    }
                    scope.service.dirstructure(path, loadingIndicator)
                        .then(function (result) {
                        if (result.directoryStructure.length === 0) {
                            delete model.children;
                            return;
                        }
                        for (var i in result.directoryStructure) {
                            result.directoryStructure[i].collapsed = true;
                            result.directoryStructure[i].children = [];
                            result.directoryStructure[i].parrentPath = path;
                            result.directoryStructure[i].loadMore = scope.loadDirStructure;
                            result.directoryStructure[i].loadingIndicator = {
                                refCount: 0,
                                state: false
                            };
                            model.children.push(result.directoryStructure[i]);
                        }
                        model.children.sort(function (a, b) {
                            if (a.label < b.label)
                                return -1;
                            if (a.label > b.label)
                                return 1;
                            return 0;
                        });
                        if (!scope.viewModel.isAlreadyLoaded) {
                            scope.checkUserFolder();
                        }
                        // scope.viewModel.treedata = result.directoryStructure
                    }, function (error) {
                    });
                };
                scope.init = function () {
                    scope.loadDirStructure('/', { children: scope.viewModel.treedata }, scope.viewModel.loadingIndicator);
                }();
                scope.treeFilter = function (item) {
                    if (scope.viewModel.hideAllUsersFolders &&
                        !isNaN(item.label) &&
                        (!scope.service.userModel.userId || (scope.service.userModel.userId).toString() !== item.label)) {
                        return false;
                    }
                    if (scope.viewModel.hideCurrentUserFolders && !isNaN(item.label) && scope.service.userModel.userId && (scope.service.userModel.userId).toString() === item.label) {
                        return false;
                    }
                    if (scope.viewModel.hideOldFolders && item.label.indexOf('.old') !== (-1)) {
                        return false;
                    }
                    if (scope.viewModel.hideTmpFolders && item.label.indexOf('tmp') !== (-1) && item.type === 'd') {
                        return false;
                    }
                    return item;
                };
                scope.dbClick = function () {
                    var selectedItem = scope.getSelectedElement(scope.viewModel.treedata);
                    if (selectedItem) {
                        scope.success(selectedItem);
                    }
                };
                scope.getSelectedElement = function (model, path) {
                    var result = null;
                    path = path ? path : '';
                    for (var i in model) {
                        if (model[i].selected === 'selected' && model[i].type !== 'd') {
                            return { file: model[i].label, path: path };
                        }
                        if (model[i].children && model[i].children.length > 0) {
                            result = scope.getSelectedElement(model[i].children, path + model[i].label + '/');
                            if (result)
                                break;
                        }
                    }
                    return result;
                };
                var onKeypressAction = function (e) {
                    e.preventDefault();
                    var charCode = (typeof e.which === "number") ? e.which : e.keyCode;
                    if (charCode !== 32) {
                        return;
                    }
                    scope.previewImage();
                };
                $document.on('keypress', onKeypressAction);
                scope.$on('$destroy', function () {
                    $document.off('keypress', onKeypressAction);
                });
                scope.previewImage = function () {
                    var selectedItem = scope.getSelectedElement(scope.viewModel.treedata);
                    if (!selectedItem) {
                        return;
                    }
                    var imageUrl = 'https://images.autoremind.us/' + encodeURIComponent(selectedItem.path + selectedItem.file) + '?' + new Date().getTime();
                    templateService.previewImage(imageUrl);
                };
            }
        };
    }]);
//# sourceMappingURL=browse-uploaded-images.directive.js.map